const USER_TYPES = {
  PRINCIPAL_INVESTIGATOR: 'Principal Investigator',
  ADDITIONAL_APPLICANT: 'Applicant',
  INSTITUTIONAL_AUTHORITY: 'Institutional Authority',
  ISO: 'Information Security Officer',
};

export default USER_TYPES;
